import {
    downloadNotificationMessage,
    fetchNotificationDetails,
    fetchNotifications,
} from '@entities/notifications/api';
import {NotificationSearchPayload} from '@entities/notifications/types';
import {fetchNotificationStatuses, fetchViolationTypes} from '@entities/violations/api';
import {ViolationDto} from '@entities/violations/types';
import api from '@shared/api';

const VIOLATIONS_PATH = 'dda/api/v1';

export const fetchViolation = async (id: string) =>
    (await api.get<ViolationDto>(`${VIOLATIONS_PATH}/violation/${id}`)).data;

export const fetchViolationNotifications = async (id: string) =>
    fetchNotifications({
        filter: {type: 'EQ', field: 'violationId', values: [id]},
        sorts: [{field: 'created', order: 'DESC'}],
        page: {page: 0, size: 20},
    } as NotificationSearchPayload);

export const fetchViolationHistory = async ({
    id,
    eventType,
    page,
    size,
}: {
    id: string;
    eventType: string | null;
    page: number;
    size: number;
}) =>
    (
        await api.post(`${VIOLATIONS_PATH}/violation/${id}/history`, {
            filter: eventType ? {type: 'EQ', field: 'eventType.code', values: [eventType]} : null,
            sorts: [{field: 'validFrom', order: 'DESC'}],
            page: {page, size},
        })
    ).data;

export const fetchViolationEventTypes = async () =>
    (
        await api.post(`${VIOLATIONS_PATH}/dict_violation_event_type/search`, {
            page: {page: 0, size: 10000},
        })
    ).data;

export {fetchNotificationStatuses, fetchViolationTypes};
export {downloadNotificationMessage, fetchNotificationDetails};
